/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import Title from "../../ui/Title";
import Text from "../../ui/Text";

const StyledPackageSection = styled.div`
  display: grid;
  gap: 8px;
  width: 100%;
`;

const PackageSectionHeader = styled.div`
  display: grid;
  gap: 4px;
`;

const PackageSectionList = styled.div`
  display: grid;
  gap: 8px;
`;

const PackageInstanceSection = ({ children, readOnly }) => {
  return (
    <StyledPackageSection>
      {!readOnly && (
        <PackageSectionHeader>
          <Title size="h3">Your packages</Title>
          <Text color="dark">If you want to use credit(s) from the package, select the package below:</Text>
        </PackageSectionHeader>
      )}

        <PackageSectionList>{children}</PackageSectionList>
    </StyledPackageSection>
  );
};

export default PackageInstanceSection;